export const INVALID_AMOUNT_MESSAGE = 'Amount is invalid.';
export const INVALID_SCALE_MESSAGE = 'Scale is invalid.';
export const INVALID_RATIOS_MESSAGE = 'Ratios are invalid.';
export const UNEQUAL_SCALES_MESSAGE = 'Objects must have the same scale.';
export const UNEQUAL_CURRENCIES_MESSAGE =
  'Objects must have the same currency.';
